'use client'
import { useContext, useEffect } from 'react'
import { useKeyPress } from 'react-use'
import { GifPanelContext } from '../../../../../components/detail/gif-panel-context-manager'

const CloseOnEsc = () => {
    const { setPanel } = useContext(GifPanelContext)
    const [isEsc] = useKeyPress('Escape')
    useEffect(() => {
        if (isEsc) {
            setPanel('none')
        }
    }, [isEsc, setPanel])
    return null
}

export default CloseOnEsc
